'use client'

import { clientPage } from '../../_lib/clientPage'

export default clientPage(() =>
  import('@/components/views/ContactView').then((m) => ({
    default: m.ContactView,
  }))
)
